<template>
  <div class="sfoot">
    <slot></slot>
    <van-button class="ccbtn" v-if="showCancelButton" square round block @click.stop="cancel">
      {{ cancelText }}
    </van-button>
    <div class="partition" v-if="showCancelButton && showConfirmButton"></div>
    <van-button class="cnbtn" square round block type="primary" @click.stop="confirm">
      {{ confirmText }}{{ confirmSubText }}
    </van-button>
  </div>
</template>

<script>
export default {
  props: {
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    confirmSubText: {
      type: String,
      default: '',
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
.sfoot {
  padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
  display: flex;
  background: var(--white);
  .van-button {
    min-width: 20px;
    height: calc(var(--w) * 40);
    padding: 0 8px;
  }
  .partition {
    padding-right: calc(var(--w) * 12);
  }
  .ccbtn {
    flex: 2;
  }
  .cnbtn {
    flex: 5;
  }
}
</style>